import React from 'react'
import { connect } from 'react-redux'
import { REDUCER, commit, change } from 'ducks/password_recovery'
import { REDUCER as LOGIN_REDUCER } from 'ducks/login'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import PasswordToggle from 'components/CustomComponents/PasswordToggle'
import { AuthPolicy } from 'components/CleanComponents/AuthPolicy/index'

import { sprintf } from 'sprintf-js'
import l8n, { e } from 'l8n'

const FormItem = Form.Item
const mapStateToProps = (state) => ({
  formSubmitted: state.app.submitForms[REDUCER] || state.app.submitForms[LOGIN_REDUCER],
  data: state.password_recovery.data
})

@connect(mapStateToProps)
@Form.create({
  onFieldsChange(props, changedFields) {
    props.dispatch(change(changedFields))
  },
  mapPropsToFields(props) {
    return {
      restore_code: Form.createFormField({ ...props.data.restore_code, value: props.data.restore_code.value }),
      password: Form.createFormField({ ...props.data.password, value: props.data.password.value }),
      passwordConfirmation: Form.createFormField({ ...props.data.passwordConfirmation, value: props.data.passwordConfirmation.value }),
    }
  }
})
class PasswordRecoveryCommitForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      passwordVisible: false,
      passwordConfirmationVisible: false
    }
  }

  onSubmit = (formSubmitted) => event => {
    event.preventDefault()
    const { form, dispatch } = this.props
    if (!formSubmitted) {
      form.validateFields((error, values) => {
        if (!error) {
          dispatch(commit(values))
        }
      })
    }
  }

  togglePassword = event => {
    this.setState({ passwordVisible: !this.state.passwordVisible })
    event.preventDefault()
  }

  togglePasswordConfirmation = event => {
    this.setState({ passwordConfirmationVisible: !this.state.passwordConfirmationVisible })
    event.preventDefault()
  }

  render() {
    const { form, formSubmitted } = this.props
    const {passwordVisible, passwordConfirmationVisible} = this.state

    return (
        <Form className="registration-form" hideRequiredMark onSubmit={this.onSubmit(formSubmitted)}>
          <FormItem label={l8n.p_restore_code}>
            {form.getFieldDecorator('restore_code', {
              rules: [
                { required: true, message: e(l8n.p_required) },
                { len: 6, message: e(sprintf(l8n.req_len, l8n.p_restore_code, 6)) },
                { pattern: /^\d+$/, message: e(l8n.req_onlyDigits) },
              ],
            })(
              <Input type="text"/>
            )}
          </FormItem>
          <FormItem label={l8n.p_password} className="password-input">
            {form.getFieldDecorator('password', {
              rules: [
                { required: true, message: e(l8n.p_required) },
                { min: 6, message: e(l8n.p_minLengthPassword) },
                { pattern: /^.*[A-ZА-Я].*$/, message: e(l8n.p_uppercase_letter_required) },
                { pattern: /^.*\d+.*$/, message: e(l8n.p_digit_required) },
              ],
            })(
              <Input
                prefix={<Icon type="lock"/>}
                type={!this.state.passwordVisible ? "password" : "text" }
                placeholder={l8n.p_password}
                suffix={<PasswordToggle visible={passwordVisible} onToggle={this.togglePassword}/>}
              />,
            )}
          </FormItem>
          <FormItem label={l8n.p_password_confirm} className="password-input">
            {form.getFieldDecorator('passwordConfirmation', {
              rules: [
                { required: true, message: e(l8n.p_required) },
                { min: 6, message: e(l8n.p_minLengthPassword) },
                { pattern: /^.*[A-ZА-Я].*$/, message: e(l8n.p_uppercase_letter_required) },
                { pattern: /^.*\d+.*$/, message: e(l8n.p_digit_required) },
              ],
            })(
              <Input
                prefix={<Icon type="lock"/>}
                type={!this.state.passwordConfirmationVisible ? "password" : "text" }
                placeholder={l8n.p_password}
                suffix={<PasswordToggle visible={passwordConfirmationVisible} onToggle={this.togglePasswordConfirmation}/>}
              />,
            )}
          </FormItem>
          <div className="form-actions">
            <Button type="primary" htmlType="submit" className="registration-form-button" loading={formSubmitted}>
              {l8n.p_change_password}
            </Button>
            <span className="ml-3 register-link">
            </span>
          </div>
          <AuthPolicy/>
        </Form>
    )
  }
}

export default PasswordRecoveryCommitForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/PasswordRecoveryForm/PasswordRecoveryCommitForm/index.js